module.exports = {
    props: ['user'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                exchange_email : '',
                exchange_username : '',
                exchange_password : '',
                exchange_server_address : '',
                client_message : '',
                client_error : '',
                isDepartment: false
            }), Spark.forms.exchangeSettings)
        };
    },


    /**
     * Bootstrap the component.
     */
    mounted() {
    },


    methods: {
        /**
         * Update the user's exchange setting.
         */
        create() {
            Spark.post('/settings/save-exchange', this.form)
                .then((data) => {
                   if(data.status ==401) {
                       this.form.client_error = true;
                       this.form.client_message = data.message;
                   }else{
                       this.form.client_error = false;
                       this.form.client_message = 'Exchange configured successfully';
                       setTimeout(function(){
                        $("#msExchangeModal").modal("hide");
                        window.location.reload()
                       },2000 )
                   }
                });
        }
    }
};
